import { Service } from '@roc/feature-app-core';

const url = {
  GET_TYPICAL_VALUE_DATA: '/api/v1/property/ds/typicalValueData',
}

export class DSPropertyService extends Service {
  getTypicalValueData(zipCode: string) {
    return this.get(url.GET_TYPICAL_VALUE_DATA, { zipCode });
  }
}